import { render } from "./ModalSupplier_responsibles.vue?vue&type=template&id=7e966bfe"
import script from "./ModalSupplier_responsibles.vue?vue&type=script&lang=js"
export * from "./ModalSupplier_responsibles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__